export const ParticlesParams = {
  fullScreen: {
    enable: false,
  },
  background: {
    color: {
      value: "transparent",
    },
  },
  detectRetina: true,
  fpsLimit: 60,
  interactivity: {
    events: {
      resize: true,
    },
  },
  particles: {
    number: {
      value: 160,
      density: {
        enable: true,
        area: 800,
      },
    },
    color: {
      value: "#ffffff",
    },
    opacity: {
      value: {
        min: 0.15,
        max: 0.45,
      },
      animation: {
        enable: true,
        speed: 0.6,
        minimumValue: 0.15,
      },
    },
    size: {
      value: {
        min: 1,
        max: 3,
      },
      animation: {
        enable: true,
        speed: 2,
        minimumValue: 1,
        sync: false,
      },
    },
    move: {
      enable: true,
      random: true,
      direction: "bottom",
      speed: {
        min: 0.2,
        max: 1,
      },
      straight: false,
      outModes: {
        default: "out",
      },
    },
    links: {
      enable: false,
    },
    shape: {
      type: "circle",
    },
  },
};